const baseProductionCdnUrl = 'https://res-1.cdn.office.net/files/fabric-cdn-prod_20230815.002/';

/** @internal */
export const TestImages = {
  choiceGroupBarUnselected: baseProductionCdnUrl + 'office-ui-fabric-react-assets/choicegroup-bar-unselected.png',
  choiceGroupBarSelected: baseProductionCdnUrl + 'office-ui-fabric-react-assets/choicegroup-bar-selected.png',
  choiceGroupPieUnselected: baseProductionCdnUrl + 'office-ui-fabric-react-assets/choicegroup-pie-unselected.png',
  choiceGroupPieSelected: baseProductionCdnUrl + 'office-ui-fabric-react-assets/choicegroup-pie-selected.png',
  documentPreview: baseProductionCdnUrl + 'office-ui-fabric-react-assets/document-preview.png',
  documentPreviewTwo: baseProductionCdnUrl + 'office-ui-fabric-react-assets/document-preview2.png',
  documentPreviewThree: baseProductionCdnUrl + 'office-ui-fabric-react-assets/document-preview3.png',
  iconOne: baseProductionCdnUrl + 'office-ui-fabric-react-assets/icon-one.png',
  iconPpt: baseProductionCdnUrl + 'assets/item-types/32/pptx.png',
  personaFemale: baseProductionCdnUrl + 'office-ui-fabric-react-assets/persona-female.png',
  personaMale: baseProductionCdnUrl + 'office-ui-fabric-react-assets/persona-male.png',
};
